// this component was automatically generated by IconGlyph.template.js
import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useFeatureGate } from '@trello/feature-gate-client';
import { useLazyComponent } from '@trello/use-lazy-component';

import { Icon } from '../components/Icon';
import type { Color, GlyphProps } from '../components/Icon/Icon.types';

const StickerIconGlyph = () => {
  return (
    <svg
      width="24"
      height="24"
      role="presentation"
      focusable="false"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.9913 22C6.47244 21.9953 2 17.5199 2 12C2 6.47715 6.47715 2 12 2C17.5194 2 21.9944 6.47151 22 11.9896C22.0028 12.2553 21.8994 12.5149 21.7071 12.7071L12.7071 21.7071C12.5153 21.8989 12.2565 22.0023 11.9913 22ZM4 12C4 7.58172 7.58172 4 12 4C15.9888 4 19.2957 6.91917 19.901 10.7377C19.4642 10.6737 18.9449 10.625 18.375 10.625C16.7209 10.625 14.5466 11.0392 12.7929 12.7929C11.0392 14.5466 10.625 16.7209 10.625 18.375C10.625 18.9449 10.6737 19.4642 10.7377 19.901C6.91918 19.2957 4 15.9888 4 12ZM14.2071 14.2071C15.4534 12.9608 17.0292 12.625 18.375 12.625C18.5714 12.625 18.7609 12.6322 18.9412 12.6446L12.6446 18.9412C12.6322 18.7609 12.625 18.5714 12.625 18.375C12.625 17.0291 12.9608 15.4534 14.2071 14.2071Z"
        fill="currentColor"
      />
    </svg>
  );
};

export const StickerIcon: FunctionComponent<GlyphProps> = (props) => {
  const { testId, dangerous_className, size, color, label, block } = props;
  const { value: isIconFlagEnabled } = useFeatureGate('trello_ads_icons');

  const LazyAdsIcon = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "ADS-StickerIcon" */ '@atlaskit/icon/core/note'
      ),
    { namedImport: 'default', preload: false },
  );

  const adsIconSize = size === 'medium' || size === 'small' ? size : undefined;

  return isIconFlagEnabled ? (
    <span className={dangerous_className}>
      <ErrorBoundary
        tags={{
          ownershipArea: 'trello-ghost',
          feature: 'ADS Icon',
        }}
      >
        <ChunkLoadErrorBoundary fallback={null}>
          <Suspense fallback={null}>
            <LazyAdsIcon
              label={label || ''}
              testId={testId || 'StickerIcon'}
              color={color as Color}
              size={adsIconSize}
            />
          </Suspense>
        </ChunkLoadErrorBoundary>
      </ErrorBoundary>
    </span>
  ) : (
    <Icon
      testId={testId || 'StickerIcon'}
      size={size}
      dangerous_className={dangerous_className}
      color={color}
      block={block}
      label={label}
      glyph={StickerIconGlyph}
    />
  );
};
